import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import styled from 'styled-components';
import AdminBoardService from '../../service/AdminBoardService';
import { getRawFilesFromItem, normalizeName } from '../../util/FileHelpers';
import { getServiceLabel } from '../../util/Lookups';
import Button from '../atom/Button';
import TitleHeader from '../modecules/TitleHeader';

interface LabelProps {
  fontSize?: string;
  disPlay?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
  LabelColor?: string;
  fontWight?: string;
  justifyContent?: string;
  MinWidth?: string;
  Width?: string;
}

interface VocData {
  no?: number;
  title?: string;
  accept?: string;
  name?: string;
  dateTime?: string;
  content?: string;
  serviceSortation?: string;
  fileOriginName?: string;
  fileName?: string | null;
  businessFileName?: string | null;
  businessFileOriginName?: string | null;
  employmentFileName?: string | null;
  employmentFileOriginName?: string | null;
  telecomFileName?: string | null;
  telecomFileOriginName?: string | null;
  consentFileName?: string | null;
  consentFileOriginName?: string | null;
  specialBusinessFileName?: string | null;
  specialBusinessFileOriginName?: string | null;
  transmissionFileName?: string | null;
  transmissionFileOriginName?: string | null;
}

const UserVocDetailPage = () => {
  const [vocData, setVocData] = useState<VocData>({});
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      console.debug('User detail page data:', location.state);
      setVocData(location.state as VocData);
    }
  }, [location]);

  const navigateToWrite = () => {
    navigate(-1);
  };

  const downloadFile = async (fileKey?: string, fileName?: string) => {
    const response = await AdminBoardService.fileDownload(vocData.no, fileKey, fileName);
    if (response.status === 'success') {
      return;
    }
  };

  return (
    <UserDetailWrapper>
      <TitleHeader
        title={'상세페이지'}
        subTitle={' 추가 문의사항이 있으실 경우 글쓰기 버튼을 클릭해주세요.'}
      />
      <UserVocDetailBoardView>
        <UserDetailLabel
          fontSize={'17px'}
          disPlay={'flex'}
          marginTop={'80px'}
          LabelColor={'#388fc0'}
          fontWight={'800'}
          justifyContent={'flex-end'}
        >
          No.{vocData.no}
        </UserDetailLabel>
        <UserVocDetailBoardViewTop>
          <UserDetailLabel fontSize={'20px'} LabelColor={'#666'} fontWight={'600'}>
            제목 : {vocData.title}
          </UserDetailLabel>
          <UserVocDetailBoardViewCnt>
            <UserDetailLabelState>
              <p>처리상태 |</p>
              {vocData.accept === '대기' ? ' 접수 대기 중' : ' 접수 완료'}
            </UserDetailLabelState>
            <UserDetailLabelWriter>
              <p>작성자 | </p>
              {vocData.name}
            </UserDetailLabelWriter>
            <UserDetailLabelDate>
              <p>작성일자 |</p>
              {vocData.dateTime}
            </UserDetailLabelDate>
          </UserVocDetailBoardViewCnt>
        </UserVocDetailBoardViewTop>
        <UserVocDetailBoardViewContent>{vocData.content}</UserVocDetailBoardViewContent>
        <UserVocDetailBoardViewFileLine>
          <UserVocDetailBoardViewFile>
            <UserDetailLabel marginRight="17px" fontSize="20px" fontWight="600" LabelColor="#666">
              첨부파일:
            </UserDetailLabel>
            {(() => {
              const rawFiles = getRawFilesFromItem(vocData);
              const files = rawFiles.map(f => {
                const origin = normalizeName(f.originName);
                const stored = normalizeName(f.storedName);
                const display = origin || stored;
                return { ...f, displayName: display, downloadName: origin || stored };
              });
              console.debug('User detail files:', files);
              const available = files.filter(f => !!f.displayName);
              if (available.length === 0)
                return <UserDetailLabelFileName>첨부파일 없음</UserDetailLabelFileName>;
              return (
                <div>
                  {available.map((f, idx) => (
                    <div key={idx} style={{ marginBottom: '6px' }}>
                      <UserDetailLabelFileName
                        onClick={() => {
                          downloadFile(f.key, f.downloadName as string);
                        }}
                      >
                        {f.label} : {f.displayName}
                      </UserDetailLabelFileName>
                    </div>
                  ))}
                </div>
              );
            })()}
          </UserVocDetailBoardViewFile>
          <UserDetailServiceCate>
            <UserDetailLabelService>서비스 분류</UserDetailLabelService>
            <UserDetailLabel fontSize={'16px'} LabelColor={'#888'} Width={'100px'}>
              {getServiceLabel(vocData.serviceSortation)}
            </UserDetailLabel>
          </UserDetailServiceCate>
        </UserVocDetailBoardViewFileLine>
      </UserVocDetailBoardView>
      <UserVocDetailButton>
        <Button
          onClick={navigateToWrite}
          text={'글쓰기'}
          backgroundColor={'#388fc0'}
          fontColor={'white'}
          borderRadius={'5px'}
          marginTop={'10px'}
        />
      </UserVocDetailButton>
    </UserDetailWrapper>
  );
};

const UserDetailWrapper = styled.div`
  width: 60%;
  margin-top: 50px;
  @media ${props => props.theme.device.laptop} {
    width: 80%;
  }
`;

const UserVocDetailBoardView = styled.div``;
const UserVocDetailBoardViewTop = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #388fc0;
  align-items: center;
  padding-bottom: 17px;
  word-break: keep-all;
`;

const UserVocDetailBoardViewCnt = styled.div`
  display: flex;
  @media ${props => props.theme.device.mobile} {
    display: flex;
    flex-direction: column;
    text-align: right;
  }
`;

const UserDetailLabelState = styled.label`
  font-size: 17px;
  color: #888;
  font-weight: 600;
  display: flex;
  justify-content: flex-end;
  @media ${props => props.theme.device.tablet} {
    color: #888;
    font-weight: 600;
    margin-bottom: 5px;
    > p {
      display: none;
    }
  }
`;

const UserDetailLabelWriter = styled.label`
  font-size: 17px;
  color: #888;
  font-weight: 600;
  display: flex;
  margin-left: 15px;
  justify-content: flex-end;
  @media ${props => props.theme.device.tablet} {
    color: #888;
    font-weight: 600;
    margin-left: 0;
    margin-bottom: 5px;
    > p {
      display: none;
    }
  }
`;

const UserDetailLabelDate = styled.label`
  font-size: 17px;
  color: #888;
  font-weight: 600;
  margin-left: 15px;
  display: flex;
  @media ${props => props.theme.device.tablet} {
    color: #888;
    font-weight: 600;
    margin-left: 0;
    > p {
      display: none;
    }
  }
`;

const UserDetailLabelFileName = styled.label`
  font-size: 16px;
  color: #888;
  &:hover {
    font-size: 16px;
    color: #888;
    cursor: pointer;
    border-bottom: 1px solid black;
  }
`;

const UserVocDetailBoardViewFile = styled.div`
  display: flex;
  align-items: center;
`;
const UserVocDetailBoardViewFileLine = styled.div`
  border-bottom: 2px solid #dcdcdc;
  padding-bottom: 17px;
  display: flex;
  justify-content: space-between;
  @media ${props => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const UserVocDetailButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 100px;
`;

const UserVocDetailBoardViewContent = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #666;
  line-height: 1.4;
  min-height: 450px;
  margin-top: 20px;
  white-space: pre-wrap;
  padding-bottom: 30px;
  word-break: break-all;
`;
const UserDetailServiceCate = styled.div`
  display: flex;
  align-items: center;
`;

const UserDetailLabelService = styled.div`
  font-size: 20px;
  color: #666;
  font-weight: 600;
  margin-right: 12px;
  display: flex;
`;

const UserDetailLabel = styled.label<LabelProps>`
  font-size: ${props => props?.fontSize};
  display: ${props => props.disPlay};
  margin-top: ${props => props.marginTop};
  margin-left: ${props => props.marginLeft};
  margin-right: ${props => props.marginRight};
  margin-bottom: ${props => props.marginBottom};
  color: ${props => props.LabelColor};
  font-weight: ${props => props.fontWight};
  justify-content: ${props => props.justifyContent};
  min-width: ${props => props.MinWidth};
  width: ${props => props.Width};
`;

export default UserVocDetailPage;
